import { render, staticRenderFns } from "./PostBanner.vue?vue&type=template&id=4af35e66&scoped=true&"
import script from "./PostBanner.vue?vue&type=script&lang=js&"
export * from "./PostBanner.vue?vue&type=script&lang=js&"
import style0 from "./PostBanner.vue?vue&type=style&index=0&id=4af35e66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af35e66",
  null
  
)

export default component.exports